import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockTypeConsts } from '../setting/BlockTypeConsts';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class ARSceneSettingAttribute extends AbstractBlock {
  constructor() {
    super(BlockTypeConsts.AR_SCENE_SETTING_ATTRIBUTE, t.to('ARシーン', 'ar_scene'));
    this.setNameForCode('arjs');
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setSceneColor(block);

    ShapeSettings.setTitleField(block, this.title);

    const debugUIEnabled = new Blockly.FieldDropdown([
      [t.to('ノーマルモード', 'debug_hidden'), 'false'],
      [t.to('デバッグモード', 'debug_show'), 'true'],
    ]);
    block
      .appendDummyInput()
      .appendField(t.to('モード', 'ar_scene_debug'))
      .appendField(debugUIEnabled, 'debugUIEnabled');

    ShapeSettings.addAttributeOfSceneStartInput(block);
    block.setOutput(true, 'SceneAttribute');
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const debugUIEnabled = CodeSetting.getFieldValue(block, 'debugUIEnabled');

    // let str = ` ${self.name_for_code}='matrixCodeType: 3x3;detectionMode:mono_and_matrix; debugUIEnabled: ${debugUIEnabled};'
    // 	gps-camera artoolkit embedded ${debugUIEnabled === "true" ? "marker-alert" : "" } ${ attribute}`;
    const attrFix = `trackingMethod: best; sourceType: webcam; matrixCodeType: 3x3;detectionMode:mono_and_matrix; debugUIEnabled: ${debugUIEnabled};`;

    // const attrFix = `debugUIEnabled: ${debugUIEnabled};`;
    let str = CodeSetting.getAttributeCode(this.name_for_code, attrFix);
    // str += CodeSetting.getAttributeCode('artoolkit', '');
    str += CodeSetting.getAttributeCode('embedded', '');
    str += CodeSetting.getAttributeCode(
      'renderer',
      'logarithmicDepthBuffer:true;colorManagement: true;'
    );

    if (debugUIEnabled === 'true') {
      str += CodeSetting.getAttributeCode('marker-alert', '');

      // // デバッグ用のワイヤーフレーム Scene の情報が読みにいけないので設定できない。
      // let debug_frame_att = CodeSetting.getAttributeCode('wireframe', `true`);
      // debug_frame_att += CodeSetting.getAttributeCode('color', `black`);
      // debug_frame_att += CodeSetting.getAttributeCode('scale', `1 0 1`);
      // str += `
      // window.addEventListener("load",()=>{
      //   document.querySelectorAll("a-marker").forEach(marker =>{
      //     parent = marker;
      //     ${CodeSetting.getElementCode('a-box', debug_frame_att)}
      //   })
      // })
      // `;
    }
    str += attribute;

    return [str];
  }
}
